import ListingsRoutingResolver from './ListingRoutingResolver';

class AccountingPurchaseListingRoutingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "accounting-purchase"
    }
}

export default AccountingPurchaseListingRoutingResolver
